import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable, of, catchError, map } from 'rxjs';
import { IGift } from '@app/gifts/models/gift.interface';
import { GiftsService } from '@app/gifts/services/gifts.service';
import { IGiftsList } from '@app/gifts/models/gifts-list.interface';

@Injectable({
  providedIn: 'root'
})
export class GiftsListResolverService implements Resolve<IGift[]> {

  constructor(private giftsService: GiftsService) { }

  resolve(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<IGift[] | any> {
    const visitId = route.paramMap.get('visitId');

    return this.giftsService.getAvailableGifts(visitId, false)
      .pipe(
        map((giftsList: IGiftsList) => giftsList.gifts),
        catchError(_err => of(null))
      );
  }

}
